type UserListParams = {
  descending?: boolean;
  orderBy?: string;
  page?: number;
  pageSize?: number;
  search?: string;
  tenantId?: string | null;
  clientId?: string | null;
};

export const userQueryKeys = {
  all: ["users"] as const,
  lists: () => [...userQueryKeys.all, "list"] as const,
  list: (params: UserListParams) =>
    [
      ...userQueryKeys.lists(),
      params.descending,
      params.orderBy,
      params.page,
      params.pageSize,
      params.search,
      params.tenantId,
      params.clientId,
    ] as const,
  details: () => [...userQueryKeys.all, "detail"] as const,
  detail: (userId: string) => [...userQueryKeys.details(), userId] as const,
};

/**
 * Extracts tenantId and clientId from a user list query key.
 * Returns null values if the key doesn't match the expected structure.
 */
export function extractUserListContext(queryKey: unknown): {
  tenantId: string | null | undefined;
  clientId: string | null | undefined;
} {
  if (!Array.isArray(queryKey)) {
    return { tenantId: null, clientId: null };
  }

  if (queryKey[0] !== "users" || queryKey[1] !== "list") {
    return { tenantId: null, clientId: null };
  }

  const tenantId = queryKey[7] as string | null | undefined;
  const clientId = queryKey[8] as string | null | undefined;

  return { tenantId, clientId };
}
